import {
  HttpEvent,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { map, tap, Observable } from 'rxjs';
import { inject } from '@angular/core';

export const httpConfigInterceptorFN = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);

  if (request.url.endsWith('.svg')) {
    return next(request);
  }

  return next(request).pipe(
    tap({
      next: (event: HttpEvent<any>) => event,
      error: (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }
          // authService.logout();
          router.navigate(['auth/login']);
        }
      },
    }),
    map(event => {
      if (event instanceof HttpResponse) {
        if (!event.body.status) {
          throw event.body;
        }
        event = event.clone({ body: event.body.result });
      }
      return event;
    })
  );
};
